import { Injectable } from '@angular/core';
import { Asset } from '@zero/shared/util-models';
import { Observable } from 'rxjs';
import { InstrumentSearchParams } from '../../entities/instrument-search.entity';
import { InstrumentSearchEnabledService } from '../../infrastructure/instrument-search-enabled/instrument-search-enabled.service';
import { InstrumentSearchService } from '../../infrastructure/instrument-search/instrument-search.service';

@Injectable({
  providedIn: 'root',
})
export class InstrumentSearchFacadeService {
  private _hasSearchAllowanceChecked = false;
  private _isSearchEnabled = false;

  constructor(
    private _instrumentSearch: InstrumentSearchService,
    private _instrumentSearchEnabledService: InstrumentSearchEnabledService,
  ) {}

  public searchByQuery(query?: string, params?: InstrumentSearchParams) {
    return this._instrumentSearch.searchByQuery(query, params);
  }

  public searchByIsin(isin?: string, params?: InstrumentSearchParams) {
    return this._instrumentSearch.searchByIsin(isin, params);
  }

  public async isEnabled(customerId: string): Promise<boolean> {
    if (this._hasSearchAllowanceChecked) {
      return this._isSearchEnabled;
    }
    this._isSearchEnabled = await this._instrumentSearchEnabledService.isEnabled(customerId);
    this._hasSearchAllowanceChecked = true;
    return this._isSearchEnabled;
  }

  public getAssetByIsin(isin: string): Observable<Asset> {
    return this._instrumentSearch.getAssetByIsin(isin);
  }
}
